import Alert from './alert.svg';
import AlertDotDarkPink from './alert-dot-dark-pink.svg';
import ChevronDown from './chevron-down.svg';
import ChevronUp from './chevron-up.svg';
import Collapse from './collapse.svg';
import Conversions from './conversions.svg';
import Dashboards from './dashboards.svg';
import DataExport from './data-export.svg';
import Detections from './detections.svg';
import Expand from './expand.svg';
import Filter from './filter.svg';
import Funnels from './funnels.svg';
import FunnelTrends from './funnel-trends.svg';
import Hamburger from './hamburger.svg';
import Heatmap from './heatmap.svg';
import Home from './home.svg';
import Journeys from './journeys.svg';
import Metrics from './metrics.svg';
import Notes from './notes.svg';
import Notification from './notification.svg';
import RaisedHand from './raised-hand.svg';
import Retention from './retention.svg';
import People from './people.svg';
import Segments from './segments.svg';
import StarFilled from './star-filled.svg';
import StarUnfilled from './star-unfilled.svg';

export default {
  'grammar/alert': Alert,
  'grammar/alert-dot-dark-pink': AlertDotDarkPink,
  'grammar/chevron-up': ChevronUp,
  'grammar/chevron-down': ChevronDown,
  'grammar/collapse': Collapse,
  'grammar/conversions': Conversions,
  'grammar/dashboards': Dashboards,
  'grammar/data-export': DataExport,
  'grammar/detections': Detections,
  'grammar/expand': Expand,
  'grammar/filter': Filter,
  'grammar/funnels': Funnels,
  'grammar/funnelTrends': FunnelTrends,
  'grammar/hamburger': Hamburger,
  'grammar/heatmap': Heatmap,
  'grammar/home': Home,
  'grammar/journeys': Journeys,
  'grammar/metrics': Metrics,
  'grammar/notes': Notes,
  'grammar/notification': Notification,
  'grammar/people': People,
  'grammar/raised-hand': RaisedHand,
  'grammar/retention': Retention,
  'grammar/segments': Segments,
  'grammar/star-filled': StarFilled,
  'grammar/star-unfilled': StarUnfilled,
};
